/* input cell editor mixin */
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

export default {
  props: {
    /**
     * 편집할 데이터 객체
     */
    data: {
      type: Object,
      required: true,
    },
    /**
     * 편집할 필드
     */
    property: {
      type: String,
      required: true,
    },
    /**
     * 유효성 검사를 위한 validator
     */
    validation: {
      type: Function,
    },
    /**
     * 현재 편집 중인 필드
     */
    editingProp: {
      type: String,
    },
    /**
     * 필수 값 여부
     */
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * 편집할 값
       * @type {String}
       */
      value: null,
      /**
       * 원본 값
       * @type {?}
       */
      originalValue: null,
      /**
       * 값의 유효성 여부에 따라 설정할 클래스명
       * @type {String}
       */
      validationClass: '',
    };
  },
  computed: {
    /**
     * 에디터 활성화 여부
     * true일 경우 에디터 활성화
     * @author Ju
     */
    visible() {
      return isEmpty(this.data) ? false : this.data.editing && this.editingProp === this.property;
    },
    /**
     * cleqr trigger 제공 여부
     * @author Ju
     */
    clearable() {
      return !this.required;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(to) {
        if (to) {
          // editing.js의 startEdit에서 nextTick으로 focus줄 경우 아직 관찰자가 변경을 감지하고 update하기 전이라 ref를 못찾아옴.
          // 감지된 변경에 맞게 update완료 후 포커싱이 가도록 한다.
          const value = this.data[this.property];
          this.value = clone(value);
          this.originalValue = value;
          this.clearValidate();
          console.debug('[watch] editor visible change, set new value', this.value);
          this.$nextTick(() => this.$refs.editor.focus());
        }
      },
    },
  },
  methods: {
    /**
     * 편집을 종료한다.
     * @author Ju
     */
    endEdit() {
      console.debug('[cell end edit]', this.value);
      if (this.isValid(this.value)) {
        this.$emit('cell-edit-end', this.value);
      } else {
        this.cancelEdit();
      }
    },
    /**
     * 편집을 취소한다.
     * @author Ju
     */
    cancelEdit() {
      console.debug('[cell cancel edit]');
      this.$emit('cell-edit-end', this.originalValue);
    },
    /**
     * 값의 유효성을 검사한다.
     * @author Ju
     * @param  {String}  value 편집한 값
     */
    checkValid(value) {
      console.debug('[cell validation]', value);
      this.validationClass = this.isValid(value) ? '' : 'el-form-item is-error';
    },
    /**
     * 유효한 값인지 여부를 반환한다.
     * @author Ju
     * @param  {String}  value 편집한 값
     * @return {Boolean}       유효성 여부 (true: 유효, false: 유효하지않음)
     */
    isValid(value) {
      return (this.required ? !isNil(value) && value !== '' : true) && (this.validation ? this.validation(value) : true);
    },
    /**
     * 현재 validation 상태를 초기화한다.
     * @author Ju
     */
    clearValidate() {
      this.validationClass = '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/table/cell-editor/mixins/input-cell-editor.js